import React from 'react';
import { useTranslation } from 'react-i18next';

export default function AuthVisual({ className = '' }) {
  const { t } = useTranslation();

  return (
    <div className={`auth-visual ${className}`.trim()}>
      <img
        src={require('../img/auth_quantum_integrada.png')}
        alt={t('authVisualAlt')}
        className="auth-illustration"
      />
    </div>
  );
}
